import React from "react";
//Kendo Imports
import {
    Chart,
    ChartArea,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisTitle,
    ChartCategoryAxisItem,
    ChartLegend,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartTooltip,
    ChartCategoryAxisLabels
} from "@progress/kendo-react-charts";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

const PoleInspectionChart = ({ totalRejectCat, percentRejectCat, totalRejectCount, totalRejectPercent, predictiveCategories, predictiveChartData, inspectionType }) => {
    //util states
    const [page, setPage] = React.useState({ skip: 0, take: 5 });

    function pageChange(event) {
        const targetEvent = event.targetEvent;
        const take = targetEvent.value === "All" ? inspectionType.length : event.page.take;
        setPage({
            ...event.page,
            take,
        });
    };

    //graph component for total reject
    //is count is a bool true for the count graph, false for the percent
    function TotalRejectComponent({ isCount }) {

        // function tooltipRender(e) {
        //     return isCount ? `${e.point.value}` : `${e.point.value}%`;
        // }

        function tooltipRender(e) {
            // Check if points array exists to avoid the TypeError
            if (!e.points || e.points.length === 0) return null;
            return (
                <div>
                    {e.points.map((p, index) => (
                        <>
                            <p style={{ margin: '0 0 5px', fontWeight: 'bold', color: '#000000' }}>{p.category || "Category"}</p>
                            <div key={index}>
                                {isCount ? p.value : `${p.value}%`}
                            </div>
                        </>
                    ))}
                </div>
            );
        }

        return (
            <Chart>
                <ChartArea height={300} />
                <ChartTooltip shared={true} render={tooltipRender} />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={isCount ? totalRejectCat : percentRejectCat}>
                        <ChartCategoryAxisTitle text="Reject Type" />
                        <ChartCategoryAxisLabels rotation={25} />                   
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                        labels={{
                            visible: true,
                            content: e => isCount ? `${e.value}` : `${e.value}%`
                        }}
                    />
                </ChartValueAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="column"
                        data={isCount ? totalRejectCount : totalRejectPercent}
                        color="#4285f4"
                        tooltip={{ visible: true }}
                    />
                </ChartSeries>
            </Chart>
        );
    }

    //graph component for predictive analytics
    function PredictiveAnalyticsChart() {
        // function tooltipRender(e) {
        //     const { category, series, value } = e.point;
        //     return `${category} - ${series.name}: ${value}`;
        // }

        function tooltipRender(e) {
            if (!e || !e.points || e.points.length === 0) return null;
            const category = e.points[0].category;
            return (
                <div style={{ padding: '0px' }}>
                    {e.points.map((p, index) => (
                        <div key={index} >
                            <span style={{ margin: '0 0 5px', fontWeight: 'bold', color: '#000000' }}>{category || "Category"}</span> - {p.series.name}: {p.value}
                        </div>
                    ))}
                </div>
            );
        }

        return (
            <Chart>
                <ChartArea height={300} />
                <ChartLegend position="top" />
                <ChartTooltip shared={true} render={tooltipRender} />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem categories={predictiveCategories}>
                        <ChartCategoryAxisTitle text="Reject Status" />
                        <ChartCategoryAxisLabels rotation={25} /> 
                    </ChartCategoryAxisItem>
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                        labels={{
                            visible: true,
                            content: (e) => `${e.value}`,
                        }}
                    />
                </ChartValueAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="column"
                        name="Total Count YTD"
                        data={predictiveChartData.map((item) => item.TotalCountYTD)}
                        spacing={0.1}
                        color="#4285F4"
                    />
                    <ChartSeriesItem
                        type="column"
                        name="Estimated Counts"
                        data={predictiveChartData.map((item) => item.EstimatedCounts)}
                        spacing={0.1}
                        color="#051A38"
                    />
                </ChartSeries>
            </Chart>
        );
    }

    //graph component for inspection count
    function InspectionCountComponent() {

        function tooltipRender(e) {
            const t = e.dataItem != undefined ? e.dataItem : e.point.dataItem;
            return ` ${t.category} - ${t.count} - ${t.percent}%`;
        }

        function InspectionTypeName(props) {
            const { dataItem } = props;

            return (
                <td>
                    <div className="inspection-cc">
                        <div style={{ width: '16px', height: '16px', backgroundColor: dataItem.color, marginRight: "4px" }}></div>
                        <div>{dataItem.category}</div>
                    </div>
                </td>
            );
        }

        return (
            <div className="pulse-inspection-wrapper">
                <Chart className="">
                    <ChartArea height={300} />
                    <ChartLegend visible={false} />
                    <ChartTooltip render={tooltipRender} />
                    <ChartSeries>
                        <ChartSeriesItem
                            type="donut"
                            data={inspectionType}
                            field="count"
                            categoryField="category"
                            tooltip={{ visible: true }}
                        />
                    </ChartSeries>
                </Chart>
                <Grid
                    data={inspectionType.slice(page.skip, page.take + page.skip)}
                    skip={page.skip}
                    take={page.take}
                    total={inspectionType.length}
                    onPageChange={pageChange}
                    pageable={true}
                    style={{ width: '50%', height: 325, }}
                    scrollable={false}
                >
                    <Column title="Inspection Type" field="category" cells={{ data: InspectionTypeName }} />
                    <Column title="Count" field="count" width="96px" />
                    <Column title="Percent" field="percent" width="96px" />
                </Grid>
            </div>
        );
    }

    return (
        <>
            <div className="chart-section">
                <p className="pulse-chart-title">Total Reject Poles (Count):</p>
                <div className="pulse-chart-container">
                    <TotalRejectComponent isCount={true} />
                </div>
            </div>

            {/* Total Reject Poles (Percentage) */}
            <div className="chart-section">
                <p className="pulse-chart-title">Total Reject Poles (Percentage)</p>
                <div className="pulse-chart-container">
                    <TotalRejectComponent isCount={false} />
                </div>
            </div>

            {/* Inspection Type (Percentages and Quantities/Counts) */}
            <div className="chart-section">
                <p className="pulse-chart-title">Inspection Type (Percentages and Quantities/Counts):</p>
                <div className="pulse-chart-container">
                    <InspectionCountComponent />
                </div>
            </div>

            {/* Predictive Analytics Chart */}
            <div className="chart-section">
                <p className="pulse-chart-title">Projected Reject Status</p>
                <div className="pulse-chart-container">
                    <PredictiveAnalyticsChart />
                </div>
            </div>
        </>
    );
}

export default PoleInspectionChart;